import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = 'admin_token';
export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ headers: { Authorization: `Bearer ${getAdminToken()}` } });

export const createEnquiry = (data) => axios.post(`${API}/enquiries`, data).then((r) => r.data);

export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password }).then((r) => r.data);

export const listEnquiries = (params = {}) =>
  axios.get(`${API}/enquiries`, { params, ...authHeader() }).then((r) => r.data);

export const updateEnquiryStatus = (id, status) =>
  axios.patch(`${API}/enquiries/${id}/status`, { status }, authHeader()).then((r) => r.data);
export const listPayments = () => axios.get(`${API}/payments`, authHeader()).then((r) => r.data);
export const createOrder = (data) => axios.post(`${API}/payments/create-order`, data).then((r) => r.data);
export const verifyPayment = (data) => axios.post(`${API}/payments/verify`, data).then((r) => r.data);

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
